import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Language } from '../../../../../common/constants';
import {
  EndUserLicenseAgreementItemFileState,
  EndUserLicenseAgreementItemFileStateModel,
} from './end-user-license-agreement-item-file.state';
import {
  EndUserLicenseAgreementItemFileInitialState,
  EndUserLicenseAgreementItemFileLoad,
  EndUserLicenseAgreementLastItemFileLoad,
} from './end-user-license-agreement-item-file.actions';

@Injectable({ providedIn: 'root' })
export class EndUserLicenseAgreementItemFileFacade {
  eulaItemFileData$: Observable<EndUserLicenseAgreementItemFileStateModel> = this.store.select(
    EndUserLicenseAgreementItemFileState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(EndUserLicenseAgreementItemFileState.getLoaded);

  constructor(private store: Store) {}

  getEulaFileItem(eulaFileId: string): void {
    this.store.dispatch(new EndUserLicenseAgreementItemFileLoad(eulaFileId));
  }

  getLastEulaItemFile(languageCode: Language): void {
    this.store.dispatch(new EndUserLicenseAgreementLastItemFileLoad({ languageCode }));
  }

  setInitialState(): void {
    this.store.dispatch(new EndUserLicenseAgreementItemFileInitialState());
  }
}
